var identity = require('./identity'),
    overRest = require('./_overRest'),
    setToString = require('./_setToString');

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;



//////////////////
// WEBPACK FOOTER
// ./~/victory-brush-container/~/lodash/_baseRest.js
// module id = ./node_modules/victory-brush-container/node_modules/lodash/_baseRest.js
// module chunks = 1